// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".page-width[data-v-47bbc14f] {\n  width: 94%;\n  margin: 0 auto;\n}", ""]);
// Exports
module.exports = exports;
